/**
 * Use focusInputOnError on forms that needs to focus invalid fields on submit
 * If the data attribute '[data-invalid="true"]' is set on one or more input fields, the user will focus on the first occurrence
 **/

export default function focusInputOnError(formName) {
  if (!formName) {
    return
  }

  const form = document.forms[formName]
  if (form) {
    const errorElement = form.querySelector('[data-invalid="true"]')
    if (errorElement) errorElement.focus()
  }
}



// WEBPACK FOOTER //
// ./src/utils/focusInputOnError.js